import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import faceVerificationReducer from './slices/faceVerificationSlice'; // ADD THIS IMPORT

const store = configureStore({
  reducer: {
    auth: authReducer,
    faceVerification: faceVerificationReducer, // ADD THIS LINE
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['auth/login/fulfilled'],
        ignoredPaths: ['auth.user'],
      },
    }),
});

export default store;